import { WIDGET_COLORS } from '../constants/colors';
import { formatCurrencyShort, formatTopupLabel } from '../utils/formatSavingsPoints';
import type { TopupSuggestion } from '../utils/formatSavingsPoints';

type Props = {
  suggestion: TopupSuggestion;
};

export function TopupChip({ suggestion }: Props) {
  return (
    <span
      className="inline-flex items-center self-start rounded-full text-[11px] font-bold"
      style={{
        background: WIDGET_COLORS.green.bg,
        color: WIDGET_COLORS.green.text,
        padding: '3px 10px',
        marginTop: '6px',
      }}
    >
      Top up to {formatCurrencyShort(suggestion.amount.toString())} · {formatTopupLabel(suggestion.monthsSaved)}
    </span>
  );
}
